import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=3cc9038e&scoped=true&"
import script from "./Materials.vue?vue&type=script&lang=js&"
export * from "./Materials.vue?vue&type=script&lang=js&"
import style0 from "./Materials.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Materials.vue?vue&type=style&index=1&id=3cc9038e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc9038e",
  null
  
)

export default component.exports